var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetable',{attrs:{"showDelete":false,"tableData":_vm.components,"tableTitle":"Merge Components","fields":_vm.fields,"showEdit":true},on:{"table-edit-request":_vm.goToEdit}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fb59e29","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/Tariff/MergeComponents.vue
// module id = 2065
// module chunks = 1